import React, { useEffect, useState } from 'react';
import { Modal } from 'antd';
import { Provider } from 'react-redux';
import { connect } from 'react-redux';
import { hideModal } from '../store/actions';
import { Icon } from 'dlweb-components';
import Modals from '../components/modals';

const ModalRoot = (props) => {

  const [visible, setVisible] = useState(false);

  useEffect(() => {
    props.modalType !== null ? openModal() : hideModal();
  }, [props])

  const openModal = () => {
    setVisible(true);
  }

  const hideModal = () => {
    setVisible(false);
  }

  const modalOptions = {
    visible: visible,
    onOk: hideModal, 
    onCancel: hideModal, 
    destroyOnClose: true,
    forceRender: true
  }

  if (props.modalType === 'ERROR') {
    return (
      <Provider store={props.store}>
      <Modal
        {...modalOptions} 
        cancelButtonProps={{hidden: true}}
        {...props.modalProps}
        >
          <div style={{ display: 'flex'}}>
            <div style={{ width: '50px', color: '#ff4d4f' }}><Icon type="exclamation-circle" /></div>
            <div dangerouslySetInnerHTML={{ __html: props.modalContentProps.content }}></div>
          </div>
        </Modal>
      </Provider>

    )
  }
  else {
    const ModalContents = Modals[props.modalType] || null;

    return (
      <Provider store={props.store}>
        <Modal
          {...modalOptions}
          {...props.modalProps}
        >
          {props.modalType ? <ModalContents hideModal={hideModal} angularScope={props.$rootScope} {...props.modalContentProps} /> : null}
        </Modal>
      </Provider>
    )
  }
}

const mapStateToProps = state => state.modal;
const mapDispatchToProps = { hideModal };

export default connect(mapStateToProps, mapDispatchToProps)(ModalRoot);